import { render, staticRenderFns } from "./DataOverview.vue?vue&type=template&id=0363ca9a&scoped=true"
import script from "./DataOverview.vue?vue&type=script&lang=js"
export * from "./DataOverview.vue?vue&type=script&lang=js"
import style0 from "./DataOverview.vue?vue&type=style&index=0&id=0363ca9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0363ca9a",
  null
  
)

export default component.exports